import React, { useEffect, useRef, useState } from "react";
// ... all your other existing imports ...
import serverCredintials from "./constants/serverCredintials";
import { JssProvider } from "react-jss";
import classNames from "classnames";
import { ThemeProvider, createGenerateClassName } from "@material-ui/core/styles";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import defaultTheme from "./themes";
//import PageRoutes from "./router/PageRoutes";
import ViewRoutes from "./router/ViewRoutes";
import { AppStyles } from "./themes/AppStyles";
import Header from "./navigation/Header";
import LeftDrawer from "./navigation/SideNavBar";
import NavBarData from "./common/data/Navbardata";
import GlobalContext from "./common/contexts/GlobalContext";
import Login from "./components/Login";
import { default as Apiservices } from "./common";
import { useMsal } from "@azure/msal-react";
import Dashboard from "./pages/Dashboard/Dashboard";
import IdleLogoutPopup from "./IdleLogoutPopup";
import jwt from 'json-web-token';
import { useHistory } from 'react-router-dom';


(function captureApprovalToken() {
   try {
      const params = new URLSearchParams(window.location.search);
      const token  = params.get("token");
      if (token) {
         sessionStorage.setItem("pending_approval_token", token);
      }
   } catch (e) {
      console.error("approval token capture failed:", e);
   }
})();

const AD_CONFIG = serverCredintials.BuildURL.geAdAuthConfig();

const generateClassName = createGenerateClassName({
  dangerouslyUseGlobalCSS: false,
});

export default function App() {
  const timerRef = useRef(null);

  const [state, setState] = React.useState({
    theme: defaultTheme.default,
    rightDrawerOpen: false,
    navDrawerOpen:
      window &&
        window.innerWidth &&
        window.innerWidth >= defaultTheme.default.breakpoints.values.md
        ? false
        : true,
  });
  const [hideSubmenus, setHideSubmenus] = React.useState(false);
  const [spinner, setSpinner] = React.useState(true);
  const [DisplayIdlePopup, setDisplayIdlePopup] = React.useState(false);
  const history = useHistory();

  useEffect(() => {
    if (state.navDrawerOpen) {
      setHideSubmenus(true);
    } else {
      setHideSubmenus(false);
    }
  }, [state]);

  const [masterDataObj, setMasterDataObj] = React.useState([]);
  const [login, setLogin] = React.useState("home");
  const { instance, accounts } = useMsal();
  const [apiToken, setApiToken] = useState(null);

  const onLoginChange = (type) => {
    setLogin(type);
  };

  const Logout = async () => {
    const postData = {
      token: sessionStorage.getItem("token"),
    };
    await Apiservices.userLogout(postData);
    sessionStorage.clear();
    instance.logoutRedirect({
      postLogoutRedirectUri: "/railways",
    });
  };

  function handleChangeNavDrawer() {
    setState({
      navDrawerOpen: !state.navDrawerOpen,
    });
  }

  useEffect(() => {
    if (accounts?.length > 0) {
      sessionStorage.setItem('user_email', accounts[0].username)
      sessionStorage.setItem('user_name', accounts[0].name);
      // let token_result = getUserToken();
      console.log(accounts[0], '.at.................................');
      getUserAuth(accounts[0].username);
      setSpinner(false)
    }
  }, [accounts]);

  const getUserToken = async () => {
    try {
      // const response = await instance.acquireTokenSilent({
      const response = await instance.acquireTokenSilent({
        scopes: [`api://${AD_CONFIG.CLIENT_ID}/user_impersonation`],//  [`api://${AD_CONFIG.CLIENT_ID}/access_as_user`],
        account: accounts[0],
      });

      console.log("Access Token:", response.accessToken);
      return response.accessToken;

    } catch (err) {
      console.log(err);
    }
  };

  const classes = AppStyles();
  const { navDrawerOpen } = state;

  const getUserAuth = async (user_email, azure_token) => {
    if (!sessionStorage.getItem("token")) {
      let userName = user_email.toLowerCase();
      let token_result = await getUserToken();
      let userCredentials = { user_email: userName, azure_token: token_result };
      const TokenResponse = await Apiservices.getUserToken(userCredentials);
      if (TokenResponse && TokenResponse.issuccess === 1) {
        sessionStorage.setItem("isLoggedIn", "Yes");
        setApiToken(TokenResponse.token);
        sessionStorage.setItem("token", TokenResponse.token);
        sessionStorage.setItem(
          "user_email",
          accounts[0].username.toLowerCase()
        );
        sessionStorage.setItem("user_name", accounts[0].name);
        sessionStorage.setItem(
          "is_credit_note_approver",
          TokenResponse.is_credit_note_approver ? "true" : "false"
        );
      }
    } else {
      setApiToken(sessionStorage.getItem("token"));
    }
  }

  const getClientTenantId = async () => {
    let notValidUser = false;
    if (!sessionStorage.getItem('client_id')) {
      notValidUser = true;
    }
    await Apiservices.getClientDetails().then((data1) => {
      jwt.decode('TMILL_LOB', data1.data, function (err, clientTenant) {

        jwt.encode('TMILL_LOB', clientTenant.data.client_id, function (err1, client) {
          sessionStorage.setItem('client_id', client)
        })
        jwt.encode('TMILL_LOB', clientTenant.data.tenent_id, function (err2, tenant) {
          sessionStorage.setItem('tenant_id', tenant)
        })
      })

      if (notValidUser) {
        history.go(0);
      }
    });
  }

  const getMasterData = async () => {
    try {
      let masterData = {};
      masterData.listCustomers = await Apiservices.listCustomers();
      masterData.listOriginDestinations =
        await Apiservices.listOriginDestinations();
      masterData.listActiveJobs = await Apiservices.activeJobsList();
      const listStationMaster = await Apiservices.getStationMasterList();
      masterData.listStationMaster = listStationMaster?.records;
      return masterData;
    } catch (error) { }
  };

  useEffect(() => {
    setTimeout(() => { if (accounts?.length == 0) { setSpinner(false) } }, 1000);
    const fetchData = async () => {
      const masterdata = await getMasterData();
      setMasterDataObj(masterdata);
    };
    if (apiToken) {
      fetchData();
    }
  }, [apiToken]);

  useEffect(() => {
    getClientTenantId();
  }, []);

  useEffect(() => {
    const BEFORE_IDLE_TIMEOUT = 59 * 60 * 1000;
    let idleTimer;

    const resetIdleTimer = () => {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(onIdle, BEFORE_IDLE_TIMEOUT);
    };

    const onIdle = () => {
      setDisplayIdlePopup(true);
      callingFun('true');
    };

    [
      "mousemove",
      "keydown",
      "mousedown",
      "touchstart",
      "click",
      "keyup",
      "wheel",
    ].forEach((event) => {
      window.addEventListener(event, resetIdleTimer, false);
    });

    resetIdleTimer();

    return () => {
      clearTimeout(idleTimer);
      [
        "mousemove",
        "keydown",
        "mousedown",
        "touchstart",
        "click",
        "keyup",
        "wheel",
      ].forEach((event) => {
        window.removeEventListener(event, resetIdleTimer, false);
      });
    };
  }, []);

  const callingFun = (pasd_key) => {
    timerRef.current = setTimeout(function () {
      setDisplayIdlePopup(false);
      Logout();
    }, 10000);
  };

  const closeConfirmationPopup = async () => {
    setDisplayIdlePopup(false);
  };

  const updateLogout = async () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  };

  return (
    !spinner && (
      <>
        {accounts[0] && window.top === window.self ? (
          <>
            <div>
              {/* {login === "user" ? ( */}
              <JssProvider generateClassName={generateClassName}>
                <ThemeProvider theme={defaultTheme.default}>
                  <Header
                    handleChangeNavDrawer={handleChangeNavDrawer}
                    navDrawerOpen={navDrawerOpen}
                    logout={Logout}
                  />

                  <LeftDrawer
                    navDrawerOpen={navDrawerOpen}
                    handleChangeNavDrawer={handleChangeNavDrawer}
                    menus={NavBarData.menus}
                    hideSubmenus={hideSubmenus}
                  />
                  {apiToken ? (
                    <div
                      className={classNames(
                        classes.container,
                        !navDrawerOpen && classes.containerFull
                      )}
                    >
                      <GlobalContext.Provider
                        value={{ masterDatacontext: [masterDataObj, setMasterDataObj] }}
                      >
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          {/* <PageRoutes /> */}
                          <ViewRoutes />
                        </MuiPickersUtilsProvider>
                      </GlobalContext.Provider>
                    </div>
                  ) : (
                    <></>
                  )}
                </ThemeProvider>
              </JssProvider>
              {DisplayIdlePopup && (
                <IdleLogoutPopup
                  Logout={Logout}
                  updateLogout={updateLogout}
                  closeConfirmationPopup={closeConfirmationPopup}
                />
              )}
              {/* ) : (
        <div>
          <Login onLoginChange={onLoginChange} />
        </div>
      )} */}
            </div>
          </>
        ) :
          window.top !== window.self ? (
            <>
              <JssProvider generateClassName={generateClassName}>
                <ThemeProvider theme={defaultTheme.default}>
                  <Header
                    handleChangeNavDrawer={handleChangeNavDrawer}
                    navDrawerOpen={navDrawerOpen}
                    logout={Logout}
                  />

                  <LeftDrawer
                    navDrawerOpen={navDrawerOpen}
                    handleChangeNavDrawer={handleChangeNavDrawer}
                    menus={NavBarData.menus}
                    hideSubmenus={hideSubmenus}
                  />
                  {/* {apiToken ? ( */}
                  <div
                    className={classNames(
                      classes.container,
                      !navDrawerOpen && classes.containerFull
                    )}
                  >
                    <GlobalContext.Provider
                      value={{ masterDatacontext: [masterDataObj, setMasterDataObj] }}
                    >
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Dashboard />
                      </MuiPickersUtilsProvider>
                    </GlobalContext.Provider>
                  </div>
                  {/* ) : (
                    <></>
                  )} */}
                </ThemeProvider>
              </JssProvider>
            </>
          )
            : (
              <div >
                <Login onLoginChange={onLoginChange} />
              </div>
            )}
      </>
    )
  );
}
